<!-- TODO: Remove padding bottom when footer is no longer 'fixed' -->
<div class="md:container p-4 md:mx-auto pb-24 md:pb-20">
  <div class="flex items-center relative after:content after:flex-1 md:items-start md:flex-col mb-6 md:mt-6">
    <nav class="flex-1">
      <button
        pButton
        [ngClass]="{
          'hidden md:inline': mode !== EnumStoredDocumentsMode.None,
        }"
        class="font-app-medium"
        [routerLink]="contractDetailsPath">
        <i class="pi pi-arrow-left mr-2"></i>
        <span class="hidden md:inline-block">{{ "storedDocuments.backButton" | translate }}</span>
      </button>
      <button
        pButton
        *ngIf="mode !== EnumStoredDocumentsMode.None"
        class="font-app-medium md:hidden"
        (click)="closeMode()">
        <i class="pi pi-arrow-left mr-2"></i>
      </button>
    </nav>
    <h1
      [ngClass]="{
        'hidden md:block': mode !== EnumStoredDocumentsMode.None,
      }"
      class="font-app-bold text-2xl md:mt-3">
      {{ "storedDocuments.title" | translate }}
    </h1>
    <h1
      *ngIf="mode !== EnumStoredDocumentsMode.None"
      class="font-app-bold text-2xl md:mt-3 md:hidden">
      {{ titleTranslationKey | translate }}
    </h1>
    <button
      *ngIf="mode === EnumStoredDocumentsMode.CategoryManagement"
      class="flex right-0 absolute md:hidden"
      title="Informations"
      (click)="uploadInfo.toggle($event)">
      <i class="pi pi-info-circle text-medium_light text-2xl h-7 aspect-square text-center"></i>
    </button>
    <p-overlayPanel #uploadInfo>
      <p class="text-black font-app-light">
        {{ "storedDocuments.category.toggleInfo1" | translate }}
      </p>
      <p
        [innerHtml]="'storedDocuments.category.toggleInfo2' | translate"
        class="text-black mt-4"></p>
    </p-overlayPanel>
    <span
      *ngIf="documentsInformations$ | async as documentsInformations; else documentsInformationsReferenceLoading"
      class="text-dark hidden md:inline-block mt-2"
      >{{ "storedDocuments.policyLabel" | translate
      }}<span class="text-black">{{ (documentsInformations$ | async)?.reference ?? undefined }}</span></span
    >
    <ng-template #documentsInformationsReferenceLoading>
      <p-skeleton class="hidden md:block mt-4 h-4 w-60" />
    </ng-template>
  </div>
  <div class="flex flex-col md:flex-row md:divide-x divide-medium_light">
    <section
      [ngSwitch]="mode"
      class="md:w-[26rem] md:pr-8">
      <ng-container *ngSwitchDefault>
        <app-stored-documents-upload
          #documentUpload
          [documentsInformations]="(documentsInformations$ | async) ?? undefined"
          [categories]="(documentsCategories$ | async) ?? undefined"
          (validateUploadFile)="onValidateUploadFile($event)" />
      </ng-container>
      <ng-container *ngSwitchCase="EnumStoredDocumentsMode.CategoryManagement"
        ><app-stored-documents-category-management
          [categories]="(documentsCategories$ | async) ?? undefined"
          (sendNewCategoryEvent)="newCategoryEvent($event)"
          (cancelNewCategoryEvent)="cancelNewCategoryEvent($event)"></app-stored-documents-category-management
      ></ng-container>
      <ng-container *ngSwitchCase="EnumStoredDocumentsMode.FileEdition"
        ><app-stored-documents-file-edition
          [categories]="(documentsCategories$ | async) ?? undefined"
          [storedDocument]="editedDocument"
          (editionValidated)="onEditionValidated($event)"
          (editionCancelled)="onEditionCancelled()"
      /></ng-container>
    </section>
    <section
      [ngClass]="{
        'hidden md:block': mode !== EnumStoredDocumentsMode.None,
      }"
      class="flex-auto md:min-w-[36rem] mt-6 md:mt-0 md:pl-16">
      <app-stored-documents-list
        [documents]="(documentsInformations$ | async)?.storedDocuments ?? undefined"
        [categories]="(documentsCategories$ | async) ?? undefined"
        (downloadDocumentAction)="onDownloadDocument($event)"
        (editDocumentAction)="onEditDocument($event)"
        (deleteDocumentAction)="onDeleteDocument($event)"
        (editListEventEmitter)="editListEvent($event)" />
    </section>
  </div>
</div>

